import React, {useState} from "react";
import {connect} from "react-redux";
import Panel from "../../../panel/Panel";
import Form from "./forms/New";
import {removeAction as removePanelAction} from "../../../../actions/panel";
import { InsuranceOutlined } from '@ant-design/icons';
import { Button, Result, Spin } from "antd";
import EntityLoader from "../../../common/EntityLoader";

const Title = ({entity}) => <span>
    <InsuranceOutlined /> {!!entity ? 'Gruppe hinzufügen' : '404 - Not Found'}
</span>;

const Content = connect(
    null,
    dispatch => ({
        onRemovePanel: (uniqueKey) => dispatch(removePanelAction(uniqueKey)),
    })
)(({entity, entityId, onRemovePanel}) => <>
    {entity
        ? <Form siteId={entityId}/>
        : <Result
            status="404"
            title="404"
            subTitle="Sorry, the page you visited does not exist."
            extra={<Button type="primary" onClick={() => onRemovePanel(`cookieconsentsitegroups:${entityId}:new`)}>close</Button>}
        />
    }
</>);

export default ({siteId}) => {
    const [loading, setLoading] = useState(true);

    return <Panel
        backgroundColor="#882f9c"
        id={`cookieconsentsitegroups:${siteId}:new`}
        title={
            <EntityLoader entityId={siteId}>
                <Title/>
            </EntityLoader>
        }
    >
        <Spin spinning={loading}>
            <EntityLoader entityId={siteId} onFinally={() => setLoading(false)}>
                <Content/>
            </EntityLoader>
        </Spin>
    </Panel>
};
